export default __webpack_public_path__ + "static/media/125.8c4c137b.jpg";